/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*===================================================================
 */

import { ErrorHandler, Injectable } from '@angular/core';

declare var newrelic;

@Injectable({ providedIn: 'root' })
export class ErrorHandlerService implements ErrorHandler {
  constructor() {}

  handleError(error, logToConsole = true) {
    try {
      if (newrelic) {
        newrelic.noticeError(error);
      }
    } catch (err) {}

    if (logToConsole) {
      console.error(error);
    }
  }
}
